module.exports = __webpack_public_path__ + "static/media/p0_6.c0cbf870.png";